// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          welcome: 'Welcome to our website!',
          language: 'Language',
        },
      },
      hi: {
        translation: {
          welcome: 'हमारी वेबसाइट में आपका स्वागत है!',
          language: 'भाषा',
        },
      },
      zh: {
        translation: {
          welcome: '欢迎来到我们的网站！',
          language: '语言',
        },
      },
      ja: {
        translation: {
          welcome: '私たちのウェブサイトへようこそ！',
          language: '言語',
        },
      },
    },
  });

export default i18n;
